import { Anchor, Box, ChevronIcon, Flex, Text, Title } from "@mantine/core";
import Link from "next/link";
import { ReactElement } from "react";
import { useStyles } from "./AccordionControlLink.styled";
import { IAccordionControlLinkProps } from "./types";

export default function AccordionControlLink({
  icon,
  title,
  description,
  href,
  ...anchorProps
}: IAccordionControlLinkProps): ReactElement {
  const { classes, cx } = useStyles();

  return (
    <Anchor
      className={cx(classes.root)}
      component={Link}
      href={href}
      {...anchorProps}
    >
      <Flex
        align={{ base: "flex-start", sm: "center" }}
        direction="row"
        gap="xs"
        justify="space-between"
        wrap="nowrap"
        maw="100%"
      >
        {icon && (
          <Flex align="center" miw={16} mt={{ base: 3, sm: 1 }} ta="center">
            <Box display="inline-block" fz={0} mx="auto">
              {icon}
            </Box>
          </Flex>
        )}

        <Flex
          align={{ base: "flex-start", sm: "center" }}
          direction={{ base: "column", sm: "row" }}
          justify="space-between"
          wrap="nowrap"
          maw="100%"
          ta="left"
          w="100%"
        >
          {typeof title === "string" ? (
            <Title m={0} maw="100%" order={2} size="h6">
              {title}
            </Title>
          ) : (
            title
          )}

          {description && (
            <Box maw={{ base: "100%", sm: "60%" }} w="100%">
              {typeof description === "string" ? (
                <Text td="none" fz="sm" w="100%">
                  {description}
                </Text>
              ) : (
                description
              )}
            </Box>
          )}
        </Flex>

        <ChevronIcon className={classes.chevronIcon} />
      </Flex>
    </Anchor>
  );
}
